function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
import React, { forwardRef } from 'react';
import { jsx as ___EmotionJSX } from "@emotion/react";
var SvgFlagSk = /*#__PURE__*/forwardRef(function (props, svgRef) {
  return ___EmotionJSX("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), ___EmotionJSX("path", {
    fill: "#fff",
    d: "M0 0h25v20H0z"
  }), ___EmotionJSX("path", {
    fill: "#BE1E2D",
    d: "M0 13h25v7H0z"
  }), ___EmotionJSX("path", {
    fill: "#fff",
    d: "M0 0h25v8H0z"
  }), ___EmotionJSX("path", {
    fill: "#1B5786",
    d: "M0 7h25v6H0z"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h25v20H0V0zm23.75 18.75V1.25H1.25v17.5h22.5z",
    fill: "#2D2926",
    opacity: 0.15
  }), ___EmotionJSX("path", {
    d: "M8.363 5C6.375 5 4.75 5.625 4.75 6.325v4.3a5.35 5.35 0 003.613 4.213c1.175 0 3.625-2.213 3.625-4.213v-4.3c0-.7-1.625-1.325-3.625-1.325z",
    fill: "#BE1E2D"
  }), ___EmotionJSX("path", {
    d: "M8.675 11.25V9.038h2.037v-.625H8.675V7.65h1.412v-.625H8.675v-1.25H8.05v1.25h-1.4v.625h1.4v.763H6.025v.625H8.05v2.212c.104-.011.209-.011.312 0 .104-.013.21-.013.313 0z",
    fill: "#fff"
  }), ___EmotionJSX("path", {
    d: "M10.5 11.787a1 1 0 00-.762.388 1.475 1.475 0 00-1.063-.925 1.257 1.257 0 00-.313 0c-.589.036-1.111.39-1.362.925a1 1 0 00-.75-.388.988.988 0 00-.862.55 5.2 5.2 0 002.975 2.4 4.762 4.762 0 003-2.4.988.988 0 00-.863-.55z",
    fill: "#1B5786"
  }), ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.313 5.887c0-.775 1.812-1.412 4.05-1.412 2.237 0 4.05.637 4.05 1.412v4.826c0 2.2-2.8 4.7-4.05 4.7-1.088 0-4.05-2.463-4.05-4.7V5.887zm7.05 6.45a3.65 3.65 0 00.537-1.724V6.387c0-.687-1.588-1.25-3.55-1.25-1.962 0-3.55.563-3.55 1.25v4.226c.032.616.23 1.212.575 1.725a5.2 5.2 0 002.975 2.4 4.763 4.763 0 003.013-2.4z",
    fill: "#fff"
  }));
});
export default SvgFlagSk;